export default "__VITE_ASSET__CE9HZw0z__"